import React from 'react';

import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ListIcon from '@mui/icons-material/List';

import { openPoiListingMenu } from '../../store/actions/poiListingActions';
import { CustomIconButton } from '../Button/CustomIconButton';


export const FeaturesListButton = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const openPoiListing = async () => {
    dispatch(openPoiListingMenu());
  };

  return (
    <CustomIconButton id='poi_listing_open' ariaControls="poi-disclosure" tooltip={t('poiListing.open')} ariaLabel={t('poiListing.open')} callback={openPoiListing} icon={ListIcon}></CustomIconButton>
  );
};